import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ApiService } from '../../../../core/services/api.service';
import { IApiKeyFormPayload, IApikeyListResponse } from '../models/apikeys.models';

@Injectable({
	providedIn: 'root',
})
export class ApikeyService extends ApiService {
	public list(body: any): Observable<IApikeyListResponse> {
		return this.http.post<IApikeyListResponse>(environment.apiUrl + `/api-keys`, body, {
			headers: this.getHeaders(),
		});
	}

	public update(id: any, body: IApiKeyFormPayload): Observable<any> {
		return this.http.patch<any>(environment.apiUrl + `/api-key/${id}`, body, {
			headers: this.getHeaders(),
		});
	}

	public create(body: IApiKeyFormPayload): Observable<any> {
		return this.http.post<any>(environment.apiUrl + `/api-key`, body, {
			headers: this.getHeaders(),
		});
	}

	public delete(id: any): Observable<any> {
		return this.http.delete<any>(environment.apiUrl + `/api-key/${id}`, {
			headers: this.getHeaders(),
		});
	}
}
